import axios from 'axios';
import { API_URL } from '../../lib/const';

export const cpaVisited = token => axios.post(`${API_URL}/onboarding/enrollments/${token}/cpa_visited`).then(response => response.data);

export default cpaVisited;
